export default function getRiskTitleKeyByValue(
  value: number | null | undefined,
) {
  if (value === null || value === undefined) return 'undefined';
  if (value >= 75) return 'high';
  if (value > 25) return 'middle';
  return 'low';
}
